import { render, staticRenderFns } from "./DropdownMessage.vue?vue&type=template&id=1d009a3e&scoped=true&"
import script from "./DropdownMessage.vue?vue&type=script&lang=ts&"
export * from "./DropdownMessage.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMessage.vue?vue&type=style&index=0&id=1d009a3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d009a3e",
  null
  
)

export default component.exports